export default "__VITE_ASSET__343a929f__"